import { Quotation, EmissionLog } from 'data-layer-cr/dist/models';
import {
  PROCESSING_EMISSION,
  EMITTED,
} from 'data-layer-cr/dist/constants/quotationStatus';
import {
  POLICY_ACTIVATION_SUCCESS,
  PAYMENT_APPLICATION_SUCCESS,
  PAYMENT_APPLICATION_FAILURE,
  PERSON_CREATION_SUCCESS,
  POLICY_CREATION_SUCCESS,
  PAYMENT_APPROVED,
  PERSON_CREATION_FAILURE,
  POLICY_CREATION_FAILURE,
  POLICY_ACTIVATION_FAILURE,
} from 'data-layer-cr/dist/constants/paymentCodes';

/**
 * Attemps to extract the emission status id from the provided nullable emisison log.
 *
 * @param emissionLog - The emission log returned by the service
 */
export function attemptToExtractEmissionStatusCode(
  emissionLog: EmissionLog | null,
): number {
  if (!emissionLog) {
    return -1;
  }
  return emissionLog.statusId;
}

/**
 * Returns true if the provided quotation already completed its emission process, and the
 * "final" screen must be shown to the user.
 *
 * @param quotation - The source quotation
 * @param emissionRequestId - The last code detected for this quotation's emission process
 */
export function shouldShowSuccessScreen(
  quotation: Quotation,
  emissionRequestId: string,
): boolean {
  return (
    [PROCESSING_EMISSION, EMITTED].includes(quotation.status.id) &&
    [
      POLICY_ACTIVATION_SUCCESS,
      PAYMENT_APPLICATION_SUCCESS,
      PAYMENT_APPLICATION_FAILURE,
    ].includes(emissionRequestId)
  );
}

/**
 * Returns true if the provided quotation is still pending
 *
 * @param quotation - The source quotation
 * @param emissionRequestId - The last code detected for this quotation's emission process
 */
export function isProcessingEmission(
  quotation: Quotation,
  emissionRequestId: string,
): boolean {
  return (
    quotation.status.id === PROCESSING_EMISSION &&
    [
      PERSON_CREATION_SUCCESS,
      POLICY_CREATION_SUCCESS,
      PAYMENT_APPROVED,
    ].includes(emissionRequestId)
  );
}

export function isOnError(
  quotation: Quotation,
  emissionRequestId: string,
): boolean {
  return (
    (quotation.status.id === PROCESSING_EMISSION &&
      [
        PERSON_CREATION_FAILURE,
        POLICY_CREATION_FAILURE,
        POLICY_ACTIVATION_FAILURE,
      ].includes(emissionRequestId)) ||
    (quotation.status.id === EMITTED &&
      [POLICY_ACTIVATION_FAILURE].includes(emissionRequestId))
  );
}
